var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18 8.616V6.6H6v2.016zm0 3V9.6H6v2.016zm0 3V12.6H6v2.016zm2.016-12q.816 0 1.392.576t.576 1.392v12q0 .816-.576 1.416t-1.392.6H6l-3.984 3.984v-18q0-.816.576-1.392a1.9 1.9 0 0 1 1.392-.576z"
})));
export default SvgMessage;